var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('ConfsList',{on:{"hangup":_vm.onHangup}}),_c('VideoConf',{ref:"ongoingConference"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }